import React from 'react'
import './MapComp.css';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';

const MapComp = () => {

  const containerStyle = {
    width: '100%',
    height: '100%'
  };
  
  const center = {
    lat: -3.745,
    lng: -38.523
  };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "YOUR_API_KEY"
  })

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map)
  }, [])

  return (
    <div className='MapCompMain'>
      <p style={{fontWeight:700,fontSize:20}}>Where you'll be</p>
      <p style={{fontSize:15}}>Maldives</p>
  <div className='MapCompMapDiv'> 
        {
          isLoaded &&
        <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onLoad={onLoad}
        // onUnmount={onUnmount}
      >
      </GoogleMap>
        }
          </div> 
    </div>
  )
}

export default MapComp